// http://humaan.com/custom-html-markers-google-maps/
// --------------------------------------------------

	if (typeof google != 'undefined'){

		function CustomMarker(latlng, map, args, label) {
			this.latlng = latlng;
			this.args = args;
			this.setMap(map);
			this.label = label;
		}

		CustomMarker.prototype = new google.maps.OverlayView();

		CustomMarker.prototype.draw = function() {

			var self = this;

			var div = this.div;

			if (!div) {

				div = this.div = document.createElement('div');

				div.className = 'marker-label';

				div.style.position = 'absolute';
				div.style.cursor = 'pointer';
				// div.style.width = 'auto';
				// div.style.height = 'auto';
				// div.style.background = 'white';
				div.innerHTML = self.label;

				if (typeof(self.args.marker_id) !== 'undefined') {
					div.dataset.marker_id = self.args.marker_id;
				}

				// google.maps.event.addDomListener(div, "click", function(event) {
				// 	alert('You clicked on a custom marker!');
				// 	google.maps.event.trigger(self, "click");
				// });

				var panes = this.getPanes();
				panes.overlayImage.appendChild(div);
			}

			var point = this.getProjection().fromLatLngToDivPixel(this.latlng);

			if (point) {
				div.style.left = (point.x + 28) + 'px';
				div.style.top = (point.y - 55) + 'px';
			}
		};

		CustomMarker.prototype.remove = function() {
			if (this.div) {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
			}
		};

		CustomMarker.prototype.getPosition = function() {
			return this.latlng;
		};

	}